<div
  class="top-bar"
  [ngClass]="{
    'top-bar--front-mobile': isMenuOpen,
    'top-bar--front-desktop': isFlyoutOpen,
    'top-bar--slide-up': slideUp,
  }"
>
  <ng-container>
    <div class="top-bar__row container">
      <div
        (click)="navigateToHomepage()"
        class="top-bar__row__section top-bar__row__section--logo"
      >
        <hdi-logo></hdi-logo>
        <p class="top-bar__row__section--logo__text">Partnerwelt</p>
      </div>
      <div class="top-bar__row__section top-bar__row__section--main-nav">
        <div
          class="top-bar__row__section--main-nav__item"
          [ngClass]="{
            'top-bar__row__section--main-nav__item--active':
              (!isFlyoutOpen && currentUrl.includes(item.url)) ||
              (isFlyoutOpen && flyoutOverview.url.includes(item.url)),
          }"
          *ngFor="let item of mainMenu"
        >
          <hdi-button
            [label]="item.title"
            (click)="openFlyout(item)"
            [type]="ButtonType.CHILDREN"
            [bold]="false"
          ></hdi-button>
        </div>
      </div>
      <div class="top-bar__row__section top-bar__row__section--search">
        <div class="top-bar__row__section--search__login">
          <hdi-icon
            [iconName]="'arrow-right-to-bracket'"
            [iconPrefix]="'far'"
            [size]="Sizes.XSMALL"
          ></hdi-icon>
          <hdi-link
            class="top-bar__login-link"
            [href]="'https://www.hdi-bestandsauskunft.de/dashboard'"
            [label]="'Meine Partnerwelt'"
            [hrefType]="HrefType.EXTERNAL"
            [title]="'Meine Partnerwelt'"
            [type]="LinkType.NOSTYLES"
          ></hdi-link>
        </div>
        <!-- <hdi-search [placeholder]="'Suche'"></hdi-search> -->
      </div>
      <div class="top-bar__row__section top-bar__row__section--mobile">
        <span class="top-bar__row__section--mobile__button">
          <hdi-button
            [type]="ButtonType.LOGIN"
            [href]="'https://www.hdi-bestandsauskunft.de/dashboard'"
            [hrefType]="HrefType.EXTERNAL"
            [title]="'Meine Partnerwelt'"
            [viewport]="ViewportType.mobile"
            [sizes]="Sizes.MEDIUM"
          ></hdi-button>
          <span>Login</span>
        </span>
        <!-- <span
          class="top-bar__row__section--mobile__button"
          (click)="toggleGlobalSearch()"
        >
          <hdi-button
            [type]="ButtonType.SEARCH_NO_BG"
            [viewport]="ViewportType.mobile"
          ></hdi-button>
          <span>Suche</span>
        </span> -->
        <span class="top-bar__row__section--mobile__button">
          <hdi-burger-menu
            [closeMenu]="!isMenuOpen"
            (triggerMenu)="toggleMenu()"
            (click)="globalSearchOpen && toggleGlobalSearch()"
          ></hdi-burger-menu>
          <span>Menü</span>
        </span>
      </div>
    </div>
    <!-- <hdi-global-search
      class="top-bar__global-search"
      [ngClass]="{ 'top-bar__global-search--open': globalSearchOpen }"
      [type]="GlobalSearchType.BAR"
    ></hdi-global-search> -->
  </ng-container>

  <div *ngIf="isMenuOpen" class="top-bar__mobile-menu" #dropMenu>
    <ul>
      <hdi-dropdown-nav
        *ngFor="let menuItem of dropDownMenu"
        [menuItem]="menuItem"
        (closeMenu)="closeMenu()"
      ></hdi-dropdown-nav>
    </ul>
  </div>
</div>
<hdi-flyout
  *ngIf="isFlyoutOpen"
  [isSimple]="flyoutOverview.isSimple"
  [title]="flyoutOverview.title"
  [pages]="currentFlyout"
  [overviewUrl]="flyoutOverview.url"
  (closeFlyout)="closeFlyout()"
></hdi-flyout>
